import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import Link from 'next/link';
import { useCallback } from 'react';
import generalConfig from '@/config/general';
import featureFlags from '@/config/features';
import SEO from '@/components/head/Seo';
import Nav from '@/components/navigation/Public';
import Footer from '@/components/legal/Footer';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shadcn/components/Card';
import ButtonAuthWithGoogle from '@/components/FormElements/ButtonAuthWithGoogle';
import LoginForm from './Form';
import useLoginForm from '@/features/Auth/hooks/useLoginForm';
import useGoogleOneTap from '@/features/Auth/hooks/useGoogleOneTap';
import layoutStyles from '@/components/Layout/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var GrayAppIcon = function GrayAppIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#a)",
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "22",
        cy: "22",
        r: "22",
        fill: "#9A9EB3"
      }), /*#__PURE__*/_jsx("path", {
        d: "m31.821 26.557h-4.125v-16.5h4.125v16.5z",
        clipRule: "evenodd",
        fill: "#EBECF2",
        fillRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        d: "m24.259 34.12h-4.125v-16.5h4.125v16.5z",
        clipRule: "evenodd",
        fill: "#EBECF2",
        fillRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        d: "m16.696 29.582h-4.125v-17.325h4.125v17.325z",
        clipRule: "evenodd",
        fill: "#EBECF2",
        fillRule: "evenodd"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "a",
        children: /*#__PURE__*/_jsx("rect", {
          width: "44",
          height: "44",
          fill: "#fff"
        })
      })
    })]
  }));
};

GrayAppIcon.defaultProps = {
  fill: "none",
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
};
const SUPPORT_GOOGLE_AUTH = featureFlags.googleAuthentication;

const Login = _ref => {
  let {
    redirect = ''
  } = _ref;
  const {
    error,
    isGoogleLoginLoading,
    requestSignUp,
    handleLogin
  } = useLoginForm({
    redirect
  });
  const handleGoogleOneTapResponse = useCallback(response => {
    handleLogin('google', {
      credential: response.credential
    });
  }, [handleLogin]);
  const {
    isOneTapPromptDisplayed,
    showOneTapPrompt
  } = useGoogleOneTap({
    authContext: 'signin',
    onCredentialResponse: handleGoogleOneTapResponse
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SEO, {
      title: "Login",
      description: `${generalConfig.productName} Login`
    }), /*#__PURE__*/_jsxs("div", {
      role: "main",
      className: clsx(layoutStyles.main, '-bgc-white'),
      children: [/*#__PURE__*/_jsx(Nav, {}), /*#__PURE__*/_jsx("div", {
        className: "flex flex-col bg-gray-50 px-5 -l-publicPrimaryContainer",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex my-12 sm:mx-auto w-full items-center justify-center",
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col w-full gap-4",
            children: [/*#__PURE__*/_jsxs(Card, {
              className: "mx-auto w-full max-w-md",
              children: [/*#__PURE__*/_jsxs(CardHeader, {
                className: "items-center",
                children: [/*#__PURE__*/_jsx(GrayAppIcon, {
                  className: "size-12 rounded-full bg-accent p-2.5 text-muted-foreground"
                }), /*#__PURE__*/_jsx(CardTitle, {
                  className: "text-xl",
                  children: "Log in with your email"
                }), /*#__PURE__*/_jsx(CardDescription, {
                  children: "Enter your information to login"
                })]
              }), /*#__PURE__*/_jsx(CardContent, {
                children: /*#__PURE__*/_jsxs("div", {
                  className: "grid gap-4",
                  children: [SUPPORT_GOOGLE_AUTH && /*#__PURE__*/_jsx(ButtonAuthWithGoogle, {
                    variant: "signin",
                    requestSignUp: requestSignUp,
                    text: isOneTapPromptDisplayed ? 'Waiting...' : undefined,
                    helperText: isOneTapPromptDisplayed ? 'Please look for Google Sign In' : '',
                    loading: isGoogleLoginLoading || isOneTapPromptDisplayed,
                    onClick: () => showOneTapPrompt(() => handleLogin('google'))
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "flex items-center gap-4",
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "h-px w-full bg-input"
                    }), /*#__PURE__*/_jsx("span", {
                      className: "text-xs text-muted-foreground",
                      children: "OR"
                    }), /*#__PURE__*/_jsx("span", {
                      className: "h-px w-full bg-input"
                    })]
                  }), /*#__PURE__*/_jsx(LoginForm, {
                    handleLogin: handleLogin,
                    error: error
                  })]
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "mx-auto flex gap-1 text-sm",
              children: [/*#__PURE__*/_jsx("p", {
                children: "Don't have an account yet?"
              }), /*#__PURE__*/_jsx(Link, {
                href: "/signup",
                className: "underline",
                children: "Sign Up"
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Footer, {})]
    })]
  });
};

export default Login;